import React from 'react';
import { Box } from '@mui/material';
import NewsList from '../components/news/NewsList';

const News = () => {
  return (
    <Box>
      <NewsList />
    </Box>
  );
};

export default News;